import api from '../client';

export const BPMService = {
  getInstances: () => api.get('/bpm/instances'),
  deleteInstance: (id) => api.delete(`/bpm/instances/${id}`),
  getPending: () => api.get('/bpm/pending'),
  getHistory: () => api.get('/bpm/history'),
  getTemplates: () => api.get('/bpm/templates'),
  createTemplate: (data) => api.post('/bpm/templates', data),
  startProcess: (data) => api.post('/bpm/start', data),
  startOthersProcess: (formData) => api.post('/bpm/start-others', formData),
  approveStep: (id, data) => api.post(`/bpm/approve/${id}`, data),
  delegateStep: (id, data) => api.post(`/bpm/approve/${id}/delegate`, data),
  verifySignature: (hash) => api.get(`/bpm/verify/${hash}`),
  getTaskProcesses: (taskId) => api.get(`/bpm/task/${taskId}`),
  getProjectProcesses: (projectId) => api.get(`/bpm/project/${projectId}`),
  getInstanceSteps: (instanceId) => api.get(`/bpm/instance/${instanceId}/steps`),
  getRosreestrData: (instanceId) => api.get(`/bpm/land-analysis/rosreestr-data/${instanceId}`),
  getMapData: (instanceId) => api.get(`/bpm/land-analysis/map-data/${instanceId}`),
  captureMap: (instanceId) => api.post(`/bpm/land-analysis/map-capture/${instanceId}`),
  getInstanceComments: (instanceId) => api.get(`/bpm/instance/${instanceId}/comments`),
  addInstanceComment: (instanceId, content) => api.post(`/bpm/instance/${instanceId}/comments`, { content }),
  generateLandAnalysis: (formData) => api.post('/bpm/land-analysis/generate', formData),
  startLandAnalysis: (data) => api.post('/bpm/land-analysis/start', data)
};
